import { render } from "./WhatsappConectGroups.vue?vue&type=template&id=55fd2d70"
import script from "./WhatsappConectGroups.vue?vue&type=script&lang=js"
export * from "./WhatsappConectGroups.vue?vue&type=script&lang=js"

import "./WhatsappConectGroups.vue?vue&type=style&index=0&id=55fd2d70&lang=css"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__